import {
  Card,
  Container,
  Grid,
  Hidden,
  Icon,
  Switch,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import CircularLoader from "../../../../components/loading/circularLoader";
import SelectErp from "../../../../components/basics/SelectErp";
import TextField from "../../../../components/basics/TextFieldErp";
import { Margin } from "../../../financeiro/nfe/styles/Emissao";
import { FiltrarInadiplentesStyled } from "../styles/ControleBusca";
import { FaturamentoContratoContext } from "../contexts/FaturamentoContratoContext";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import Btn from "../../../../components/buttons/Btn";

export default function ControleBuscaCard() {
  const {
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
    filterBy,
    setFilterBy,
    typeContract,
    setTypeContract,
    billingStatus,
    setBillingStatus,
    inDays,
    setInDays,
    filterDefaulters,
    setFilterDefaulters,
    client,
    setClient,
    disabledButtonSearch,
    loadingBtnSearch,
  } = useContext(FaturamentoContratoContext);

  const { queryParams } = useContext(QueryParamsContext);
  const { handleSearchTitles, initHandleSearchTitles, handleTaxBankSlip } =
    useGerenciamentoContratoController();

  useEffect(() => {
    if (!queryParams.empresa_cnpj) return;
    initHandleSearchTitles();
  }, [
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    initHandleSearchTitles,
  ]);

  useEffect(() => {
    if (!queryParams.empresa_cnpj || !queryParams.usuario_id) return;
    handleTaxBankSlip();
  }, [queryParams.empresa_cnpj, queryParams.usuario_id, handleTaxBankSlip]);

  const [listFilerBy] = useState([
    { label: "Competência", value: "current" },
    { label: "Vencimento", value: "dueDate" },
  ]);

  const [listTypeContract] = useState([
    { label: "Todos", value: "all" },
    { label: "Recorrente", value: "recurrent" },
    { label: "Avulso", value: "single" },
  ]);

  const [listStatusBilling] = useState([
    { label: "Todos", value: "all" },
    { label: "A Faturar", value: "invoice" },
    { label: "Em Processamento", value: "processing" },
    { label: "Falha", value: "failed" },
    { label: "Faturado", value: "billed" },
  ]);

  return (
    <>
      <Margin top={20}>
        <Container maxWidth="xl">
          <Card style={{ padding: 12 }}>
            <Grid container spacing={2}>
              <Grid item container xs={4}>
                <Grid item xs>
                  <SearchSelect
                    getOptionLabel={(option) =>
                      `${option.cpfcnpj} - ${option.razao}`
                    }
                    label="Clientes"
                    setValue={setClient}
                    route="prouser/clientes/v1"
                    filter="razao,apelido,id"
                    filterTranslate="cpfcnpj"
                    error={false}
                    value={client}
                    where={{ ativo: "S" }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Data Inicial"
                  type="date"
                  size="small"
                  setValue={setInitialDate}
                  value={initialDate}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Data Final"
                  type="date"
                  size="small"
                  setValue={setFinalDate}
                  value={finalDate}
                />
              </Grid>
              <Grid item xs={2}>
                <SelectErp
                  error={false}
                  loading={false}
                  label="Data de"
                  value={filterBy}
                  setValue={setFilterBy}
                  optionsList={listFilerBy}
                  descriptionField="label"
                />
              </Grid>
              <Grid item xs={2}>
                <SelectErp
                  error={false}
                  loading={false}
                  label="Modalidade"
                  value={typeContract}
                  setValue={setTypeContract}
                  optionsList={listTypeContract}
                  descriptionField="label"
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              style={{ marginTop: 8 }}
              alignItems="flex-end"
            >
              <Grid item container xs={4}>
                <Grid item xs>
                  <SelectErp
                    error={false}
                    loading={false}
                    label="Status de faturamento"
                    value={billingStatus}
                    setValue={setBillingStatus}
                    optionsList={listStatusBilling}
                    descriptionField="label"
                  />
                </Grid>
              </Grid>
              <Grid item xs={4} xl={2}>
                <FiltrarInadiplentesStyled>
                  <Switch
                    checked={filterDefaulters}
                    onChange={() => {
                      setFilterDefaulters((current) => !current);
                      setInDays(!filterDefaulters ? "30" : false);
                    }}
                    color="primary"
                  />
                  Ignorar inadimplentes a mais de
                </FiltrarInadiplentesStyled>
              </Grid>
              <Grid item xs={2} xl={2}>
                {filterDefaulters ? (
                  <TextField
                    value={inDays}
                    setValue={setInDays}
                    label="Dias"
                    size="small"
                    maxLength={3}
                    mask="integer"
                    className="inMonths"
                  />
                ) : (
                  <></>
                )}
              </Grid>

              <Grid
                container
                item
                xs={2}
                xl={4}
                direction="row"
                justifyContent="flex-end"
              >
                <Tooltip
                  title="Buscar"
                  placement="top"
                  arrow
                  TransitionComponent={Zoom}
                >
                  <Btn
                    onClick={() => handleSearchTitles()}
                    startIcon={
                      !loadingBtnSearch ? (
                        <Icon>search</Icon>
                      ) : (
                        <CircularLoader size={14} />
                      )
                    }
                    disabled={disabledButtonSearch}
                  />
                </Tooltip>
              </Grid>
            </Grid>
          </Card>
        </Container>
      </Margin>
    </>
  );
}
